/**
 * Chat interno — helpers alinhados ao modelo ChatUsers.unreads (por membro, não por mensagem).
 */

export function getInternalChatUnreadForUser(chat, userId) {
  if (!chat || !Array.isArray(chat.users) || userId == null) return 0;
  const u = chat.users.find((x) => String(x.userId) === String(userId));
  const n = Number(u?.unreads);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

export function sumInternalChatUnreadsForUser(chats, userId) {
  if (!Array.isArray(chats) || userId == null) return 0;
  return chats.reduce((acc, c) => acc + getInternalChatUnreadForUser(c, userId), 0);
}

/** Dono da conversa (pode editar/excluir) — compara ids como string. */
export function isInternalChatOwner(chat, userId) {
  if (chat == null || userId == null) return false;
  const uid = String(userId);

  if (chat.ownerId != null && String(chat.ownerId) === uid) return true;
  if (chat.owner?.id != null && String(chat.owner.id) === uid) return true;
  // Alguns payloads trazem `owner` como id direto, não como objeto.
  if (chat.owner != null && typeof chat.owner !== 'object' && String(chat.owner) === uid)
    return true;

  // Fallback via relação de usuários do chat.
  if (Array.isArray(chat.users)) {
    const me = chat.users.find((u) => String(u?.userId ?? u?.user?.id ?? '') === uid);
    if (!me) return false;
    if (me.isOwner === true || me.owner === true) return true;
    const role = String(me.role || me.userRole || '').toLowerCase();
    if (role === 'owner') return true;
  }

  return false;
}

/** Atualiza ou insere no início da lista (última atividade / socket). */
export function upsertInternalChatInList(prev, nextChat) {
  if (!nextChat || nextChat.id == null) return prev;
  const idx = prev.findIndex((c) => String(c.id) === String(nextChat.id));
  if (idx === -1) return [nextChat, ...prev];
  const copy = [...prev];
  copy[idx] = { ...copy[idx], ...nextChat };
  return copy;
}

/** Evita mensagem duplicada quando POST + socket (ou evento repetido) chegam com o mesmo id. */
export function appendInternalChatMessage(prev, incoming) {
  if (!incoming) return Array.isArray(prev) ? prev : [];
  const list = Array.isArray(prev) ? prev : [];
  const incomingId = incoming.id;
  if (incomingId != null) {
    const exists = list.some((m) => m?.id != null && String(m.id) === String(incomingId));
    if (exists) return list;
  }
  return [...list, incoming];
}
